"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackCianMortgageLinkClick = trackCianMortgageLinkClick;
var _analytics = require("@cian/analytics");
function trackCianMortgageLinkClick() {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_sopr',
    label: 'bank_mortgage_send_app',
    page: {
      extra: {
        is_bank_mortgage: true,
        source: 'DifferentPrices'
      }
    }
  });
}